export default __webpack_public_path__ + "static/media/Demo.2b71cf02.jpg";